import MUMBAI_CONTRACT from './mumbai.json';
import POLYGON_CONTRACT from './polygon.json';

const CONFIG_CONTRACT =
  process.env.REACT_APP_ENVIRONMENT === 'production' ? POLYGON_CONTRACT : MUMBAI_CONTRACT;

export default CONFIG_CONTRACT;
